const data = [
  {
    title: "Theme Switcher (Light/Dark)",
    shortDescription:
      "Like the 'Night Mode' on your phone. Click a button to switch from white to black backgrounds instantly to save your eyes.",
    description:
      "This project teaches you that you don't need to write two separate CSS files for Light and Dark mode. Instead, we use 'CSS Variables'. We define a variable like `--bg-color`. When you click the toggle, JavaScript simply changes a class on the `<body>` tag. The CSS sees this change and automatically swaps the variable's value from White to Black. We also use `localStorage` (the browser's memory) so the site remembers your choice even if you refresh the page.",
  },
];
export default data;